'use client';

import { c as _c } from "react/compiler-runtime";
import WorldDates from '@/app/[locale]/(worlds)/[roomId]/components/WorldDates';
import WorldDescription from '@/app/[locale]/(worlds)/[roomId]/components/WorldDescription';
import WorldDeviceAvailable from '@/app/[locale]/(worlds)/[roomId]/components/WorldDeviceAvailable';
import WorldGenres from '@/app/[locale]/(worlds)/[roomId]/components/WorldGenres';
import WorldThumbnail from '@/app/[locale]/(worlds)/[roomId]/components/WorldThumbnail';
import WorldTitle from '@/app/[locale]/(worlds)/[roomId]/components/WorldTitle';
function WorldInfoDetails() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WorldTitle />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <WorldThumbnail />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div data-component="world-info-details" className="flex w-full flex-col gap-3 py-3 md:py-4">{t0}<div className="flex w-full items-start gap-4">{t1}<div className="flex min-w-0 flex-1 flex-col gap-3"><WorldGenres /><WorldDates /><WorldDeviceAvailable /></div></div><WorldDescription /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default WorldInfoDetails;